<template>
  <v-card class="elevation-1 pt-4 pb-1 px-2">
    <v-card-title
      class="ms-2 ma-0 pa-0 subtitle2 mb-4 blue-grey--text text--darken-3 font-weight-700"
      data-testid="recognitions-text-mostRecognizedTitle"
      >{{ $t('recognitions.most_recognized') }}</v-card-title
    >

    <v-card-text class="ma-0 pa-0">
      <div
        class="d-flex align-center flex-column justify-center  ma-0 pa-0"
        v-if="!mostRecognized.length && !isLoading"
      >
        <v-icon
          color="blue-grey"
          size="32"
          class="mb-3"
          data-testid="recognitions-icon-mostRecognized"
        >
          mdi-medal-outline
        </v-icon>
        <p
          data-testid="recognitions-text-mostRecognizedSubtitle"
          class="body-2 blue-grey--text"
          style="text-align: center !important;"
        >
          {{ $t('recognitions.most_recognized_subtitle') }}
        </p>
      </div>
      <template v-if="!isLoading && mostRecognized.length">
        <template v-for="item in mostRecognized">
          <UserItem
            data-testid="recognitions-component-userItem"
            class="mb-2 cursor-pointer"
            section="mostRecognized"
            :user="item.account"
            :key="item.account._id"
            :count="item.count"
          />
        </template>
      </template>
      <template v-if="isLoading">
        <UserItemSkeleton v-for="item in 3" :key="item" />
      </template>
    </v-card-text>
  </v-card>
</template>
<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import mixin from '@/mixins/mixin.vue'

import UserItem from './UserItem.vue'
import UserItemSkeleton from '@/containers/HomeView/ActivityBoard/UserItemSkeleton.vue'

export default {
  name: 'MostRecognized',

  mixins: [mixin],

  props: ['dateRange'],

  components: {
    UserItem,
    UserItemSkeleton,
  },

  data() {
    return {
      isLoading: false,
      mostRecognized: [],
    }
  },

  mounted() {
    this.getMostRecognizedAccounts()
  },

  watch: {
    dateRange: {
      async handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) await this.getMostRecognizedAccounts()
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters(['organizationId']),
  },

  methods: {
    async getMostRecognizedAccounts() {
      try {
        this.isLoading = true
        const response = await api.recognition.getTopAccounts(
          this.organizationId,
          { filters: { createdAt: this.dateRange } }
        )
        this.mostRecognized = response.data.received
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
